import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchWithResponse, ApiResult, AuthFetchError } from '@e3dc-react/shell/Types'
import { throwApiError } from 'src/Libs/api'
import { NetworkScanModel } from 'src/Routes/Installation/InstallationModel'

/** Fetches the farm network scan result for a specific EMC device */
export const scanEmcFarm = async (
  installationId: number,
  emcId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<NetworkScanModel[] | null>> => {
  try {
    const response = await authFetch<NetworkScanModel[]>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${emcId}/scan/farm`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<NetworkScanModel[]>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to scan EMC farm network:')
  }
}
